import { render } from "./TheTopHeader.vue?vue&type=template&id=a920fee0&scoped=true"
import script from "./TheTopHeader.vue?vue&type=script&lang=js"
export * from "./TheTopHeader.vue?vue&type=script&lang=js"

import "./TheTopHeader.vue?vue&type=style&index=0&id=a920fee0&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a920fee0"]])

export default __exports__